import SSPlayerController from './02-slideshare_player_controller'

var isMobile = function () {
  var isMobile = navigator.userAgent.match(
    /iPhone|iPad|iPod|Android|BlackBerry|IEMobile|webOS|Mobile|Windows Phone/i
  );
  return isMobile;
};

// Helper to detect all versions of IE based on userAgent
export function isIEAllVersion() {
  var userAgent = navigator.userAgent.toLowerCase();
  var appName = navigator.appName.toLowerCase();
  return (
    (/msie/.test(userAgent) && !/opera/.test(userAgent)) ||
    (/trident/.test(userAgent) && appName === "netscape")
  );
};

// move this to slideshare-player-utilities file;
if (!Array.prototype.indexOf) {
  Array.prototype.indexOf = function (searchElement /*, fromIndex */) {
    "use strict";
    if (this == null) {
      throw new TypeError();
    }
    var t = Object(this);
    var len = t.length >>> 0;
    if (len === 0) {
      return -1;
    }
    var n = 0;
    if (arguments.length > 0) {
      n = Number(arguments[1]);
      if (n != n) {
        // shortcut for verifying if it's NaN
        n = 0;
      } else if (n != 0 && n != Infinity && n != -Infinity) {
        n = (n > 0 || -1) * Math.floor(Math.abs(n));
      }
    }
    if (n >= len) {
      return -1;
    }
    var k = n >= 0 ? n : Math.max(len - Math.abs(n), 0);
    for (; k < len; k++) {
      if (k in t && t[k] === searchElement) {
        return k;
      }
    }
    return -1;
  };
}

/** This is the actual controller and binds model and view behaviours together */
/* @todo move model and view to this file */
function SSPlayer(config) {
  // @todo
  // sanity check. Ensure that required config parameters are present.
  // or extend with default parameters. We generally want configuration options to default
  // but we want the player to throw an exception if required content details are missing

  this.config = config;
  if (this._init) {
    this._init()
  }
}

SSPlayer.prototype._init = function () {
  // main components
  // container instance
  // slidepresenter instance
  // navigator instance - toolbar, touch etc

  // check if touch interaction exists
  var isMobiledevice = isMobile();
  this.config.touch = isMobiledevice && !cookie("nomobile");
  $.slideshareEventManager.registerPlayer(this);

  this.controller = new SSPlayerController(this.config);

  this.$playerContainer = $(this.config.container);
};

SSPlayer.prototype.play = function (index) {
  index = index || 1;
  this.controller.play(index);
};

SSPlayer.prototype.goToSlide = function (opts) {
  $.slideshareEventManager.trigger("gotoslide", opts);
};

SSPlayer.prototype.gotoCurrent = function () {
  this.controller.play(this.controller.currentPosition, true);
};

window.SSPlayer = SSPlayer;
export default SSPlayer;
